import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import FormWrapper from '@/components/forms/FormWrapper';
import NpoLoginForm from '@/components/forms/NpoLoginForm';
import LoginHeader from '@/components/LoginHeader';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const NonProfitLogin = () => {
  const colors = useColor();

  return (
    <SafeAreaView style={styles.content}>
      <FormWrapper keyboardVerticalOffset={0}>
        <View style={styles.container}>
          <LoginHeader />
          <Text style={[styles.title, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('sign_in.nonProfit.login.title')}
          </Text>
          <NpoLoginForm />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1
  },

  title: {
    fontSize: 22,
    marginBottom: 15
  }
});

export default NonProfitLogin;
